var React = require('react');

function Point (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 4.6026C0 2.06444 2.05023 0 4.5696 0C7.08897 0 9.1392 2.06444 9.1392 4.6026C9.1392 8.20903 4.99914 11.9327 4.82296 12.0896C4.75035 12.1536 4.65998 12.1856 4.5696 12.1856C4.47922 12.1856 4.38885 12.1536 4.31624 12.0891C4.14006 11.9327 0 8.20903 0 4.6026ZM2.03093 4.5696C2.03093 5.96942 3.16978 7.10827 4.5696 7.10827C5.96942 7.10827 7.10827 5.96942 7.10827 4.5696C7.10827 3.16978 5.96942 2.03093 4.5696 2.03093C3.16978 2.03093 2.03093 3.16978 2.03093 4.5696Z","fill":"#FF5F00"}));
}

Point.defaultProps = {"width":"10","height":"13","viewBox":"0 0 10 13","fill":"none"};

module.exports = Point;

Point.default = Point;
